import { MutationTree } from "vuex";
import { ManualRaiseState } from "./types";
import { getDefaultState } from "./index";
import { Region } from "../types";

export const mutations: MutationTree<ManualRaiseState> = {
	setManualRaiseShown: (state, visible) => {
		state.manualRaiseShown = visible;
	},
	setOnCompleteHandler: (state, handler) => {
		state.onCompleteHandler = handler;
	},
	setDefaultValues: (state, defaults) => {
		state.defaultValues = defaults;
	},
	setAreaMapBounds(state, bounds: any) {
		state.areaMapBounds = bounds;
	},
	setAreaLatLngString(state, latLng: string) {
		state.areaLatLngString = latLng;
	},
	setSelectedRegion(state, region: Region) {
		state.selectedRegion = region;
	},
	resetState: state => {
		Object.assign(state, getDefaultState());
	}
};
